import Vue from 'vue'
import { mq_breakpoints } from './breakpoints'
import { throttle } from 'lodash-es'

Vue.config.devtools      = true
Vue.config.productionTip = false
Vue.config.silent        = true

// Language
Vue.prototype.$language = window.PSutils.language

// Global Store
const store = Vue.observable({
  menuActive       : false,
  accountActive    : false,
  miniCartActive   : false,
  searchActive     : false,
  overlayActive    : false,
  modalActive      : false,
  closeAnnouncement: false,
  customerCountry  : 'NZ'
})

let annoucementBarWaypoint = 100

const actions = {
  toggleMenu () {
    if (store.menuActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.menuActive = true
      this.toggleOverlay()
    }
  },
  toggleAccount () {
    if (store.accountActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.accountActive = true
      this.toggleOverlay()
    }
  },
  toggleMiniCart () {
    if (store.miniCartActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.miniCartActive = true
      this.toggleOverlay()
    }
  },
  toggleSearch () {
    if (store.searchActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.searchActive = true
      this.toggleOverlay()
    }
  },
  toggleOverlay () {
    store.overlayActive = !store.overlayActive
  },
  toggleModal () {
    if (store.modalActive) {
      this.closeAll()
    } else {
      this.closeAll()
      store.modalActive = true
      document.querySelector('.app__modal').classList.add('show')
      this.toggleOverlay()
    }
  },
  closeAll () {
    store.menuActive = false
    store.accountActive = false
    store.miniCartActive = false
    store.searchActive = false
    store.overlayActive = false
    store.modalActive = false
    document.querySelector('.app__modal').classList.remove('show')
    window.PSVueNav.secondMenuIdx = null
    window.PSVueNav.thirdMenuIdx = null
    window.PSVueFooter.secondFooterIdx = null
    if (window.pageYOffset < annoucementBarWaypoint) {
      store.closeAnnouncement = false
    }
  },
  setCustomerCountry () {
    fetch('https://geolocation-db.com/json/0f761a30-fe14-11e9-b59f-e53803842572')
      .then(res => res.json())
      .then(data => store.customerCountry = data.country_code)
  }
}

Vue.prototype.$store = store
Vue.prototype.$actions = actions

// Header
window.PSVueNav = new Vue({
  name: 'Header',
  el: '.app__header',
  delimiters: ['${', '}'],
  comments: true,
  data: {
    secondMenuIdx    : null,
    thirdMenuIdx     : null,
    accountState     : '/account/login',
    newsletterPoints : false
  },
  components: {
    'instant-search': require('../Vue/Components/InstantSearch.vue').default
  },
  methods: {
    toggleMenu () {
      this.secondMenuIdx = null
      this.thirdMenuIdx = null
      this.$actions.toggleMenu()
      if (window.pageYOffset < annoucementBarWaypoint) {
        this.$store.menuActive ? this.$store.closeAnnouncement = true : this.$store.closeAnnouncement = false
      }
    },
    toggleAccount () {
      this.$actions.toggleAccount()
      if (window.pageYOffset < annoucementBarWaypoint) {
        this.$store.accountActive ? this.$store.closeAnnouncement = true : this.$store.closeAnnouncement = false
      }
    },
    toggleSearch () {
      this.$actions.toggleSearch()
    },
    updateAccountState (name) {
      this.accountState = name
    },
    closeAnnouncementOnScroll: throttle(function () {
      if (window.pageYOffset > annoucementBarWaypoint) {
        this.$store.closeAnnouncement = true
      } else {
        if (this.$store.menuActive == false) {
          this.$store.closeAnnouncement = false
        }
      }
    }, 100)
  },
  mounted () {
    this.$el.style.display = 'block'
    let headerHeight = this.$el.querySelector('.site-header').offsetHeight
    document.querySelector('.app__header').style.height = headerHeight + 'px'
    if (document.querySelector('.site-header__announcement')) {
      document.addEventListener('scroll', () => this.closeAnnouncementOnScroll())
    }
  }
})

// Account
window.PSVueAccount = new Vue({
  name: 'Account',
  el: '.account',
  delimiters: ['${', '}'],
  data () {
    return {
      accountState    : '',
      activeCTA       : 'orders',
      points          : 0,
      newsletterPoints: false,
      newAddressOpen  : false,
      editAddressID   : 0
    }
  },
  mounted () {
    this.$el.style.display = 'grid'
    this.accountState = window.location.pathname
    document.addEventListener('scroll', () => this.onScroll())
    if (this.$refs.points) {
      let email = this.$refs.points.dataset.customerEmail
      fetch(`https://emarsys-proxy.pocketsquare.co.nz/get-points?customer=${ email }`)
        .then(res => res.json())
        .then(data => {
          this.points = data.results[0].points
        })
    }
  },
  watch: {
    accountState: {
      immediate: true,
      handler () {
        this.scrollToTop()
        if (this.accountState == '/account/addresses') {
          setTimeout(() => {
            // Initialize listeners on address selectors, callback in shopify_common.js
            new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
              hideElement: 'AddressProvinceContainerNew'
            })
            // Initialize each edit form's country/province selector
            document.querySelectorAll('.address-country-option').forEach(option => {
              let formId = option.dataset.formId
              let countrySelector = 'AddressCountry_' + formId
              let provinceSelector = 'AddressProvince_' + formId
              let containerSelector = 'AddressProvinceContainer_' + formId
              new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
                hideElement: containerSelector
              })
            })
          }, 3000)
        }
      }
    }
  },
  methods: {
    updateAccountState (pathname) {
      this.accountState = pathname
      let url = window.location.origin + this.accountState
      window.history.replaceState({ path: null }, '', url)
    },
    deleteAddress (formID) {
      Shopify.postLink('/account/addresses/' + formID, {
        parameters: {
          _method: 'delete'
        }
      })
    },
    scrollToTop () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    scrollToDetails (e) {
      let scrollHeight = document.querySelector(e.target.dataset.id).offsetTop - 50
      window.scrollTo({
        top: scrollHeight,
        behavior: 'smooth'
      })
    },
    onScroll: throttle(function () {
      if (window.matchMedia(mq_breakpoints['--tablet-down']).matches) {
        let detailsWaypoint = document.querySelector('#details').offsetTop - 150
        if (window.pageYOffset >= detailsWaypoint) {
          this.activeCTA = 'details'
        } else {
          this.activeCTA = this.accountState.includes('addresses') ? 'addresses' : 'orders'
        }
      }
    }, 500)
  }
})

// Cart
window.PSVueCart = new Vue({
  name: 'Shopping Cart',
  el: '.app__cart',
  components: {
    'cart': require('../Vue/Components/Cart.vue').default
  },
  mounted () {
    this.$actions.setCustomerCountry()
    this.$el.style.display = 'block'
  }
})

// Footer
window.PSVueFooter = new Vue({
  name: 'Footer',
  delimiters: ['${', '}'],
  el: '.app__footer',
  data: {
    secondFooterIdx : null,
    secondFooterName: ''
  },
  watch: {
    secondFooterIdx () {
      this.secondFooterIdx ? this.$store.overlayActive = true : this.$actions.closeAll()
      setTimeout(() => {
        document.querySelector('.site-footer').scrollIntoView({ 
          behavior: 'smooth' 
        })
      }, 300)
    }
  },
  mounted () {
    this.$el.style.display = 'block'
  }
})

// Distributors Page
window.PSVueDistributors = new Vue({
  name: 'Distributors',
  el: '.distributors',
  components: {
    'slider': require('../Vue/Components/Slider.vue').default
  },
  data () {
    return {
      activeCountry: 'Argentina'
    }
  },
  mounted () {
    this.$el.style.display = 'block'
    document.querySelectorAll(
      `.distributors__country-list .left,
       .distributors__country-list .right`
    ).forEach(arrow => {
      arrow.addEventListener('slider_arrow_click', e => {
        let name = e.activeSlide.innerText
        let idx = e.activeSlide.dataset.index
        this.switchDistributor(name, idx)
      })
    })
  },
  methods: {
    switchDistributor (name, idx) {
      this.activeCountry = name
      window.distributors_slider.goTo(idx)
    }
  }
})

// CMS Sidebar Pages
window.PSVueCMS = new Vue({
  name: 'CMS Page',
  el: '.sidebar-layout',
  components: {
    'tabs': require('../Vue/Components/Tabs.vue').default,
    'tab' : require('../Vue/Components/Tab.vue').default,
    'accordion': require('../Vue/Components/Accordion.vue').default,
    'accordion-item' : require('../Vue/Components/AccordionItem.vue').default
  },
  data () {
    return {
      faqTree: [],
      currentPath: window.location.pathname
    }
  },
  mounted () {
    if (this.currentPath.includes('faq')) {
      let tabs = document.querySelectorAll('.faq-data h2')
      tabs.forEach((tab, idx) => {
        this.faqTree.push({
          tabTitle: tab.innerText,
          tabBody : []
        })
        let questions = this.nextUntil(tab, 'h2', 'h3')
        questions.forEach(question => {
          let answer_arr = this.nextUntil(question, 'h3', 'p')
          let answer_html = ''
          answer_arr.forEach(el => {
            answer_html += el.outerHTML
          })
          this.faqTree[idx].tabBody.push({
            question: question.innerText,
            answer  : answer_html
          })
        })
      })
    }
  },
  methods: {
    nextUntil (elem, selector, filter) {
      let siblings = []
      elem = elem.nextElementSibling

      while (elem) {
        if (elem.matches(selector)) break
        if (filter && !elem.matches(filter)) {
          elem = elem.nextElementSibling
          continue
        }
        siblings.push(elem)
        elem = elem.nextElementSibling
      }

      return siblings
    }
  }
})

// Home Page
window.PSVueHomePage = new Vue({
  name: 'Home Page',
  el: '.main-index',
  comments: true,
  components: {
    'slider': require('../Vue/Components/Slider.vue').default
  },
  created () {
    this.styleTagNodeList = document.querySelector(this.$options.el).querySelectorAll('style')
  },
  mounted () {
    for(let i = 0; i < this.styleTagNodeList.length; ++i) {
      this.$el.appendChild(this.styleTagNodeList[i])
    }
  }
})

// Overlay
window.PSVueOverlay = new Vue({
  name: 'Overlay',
  el: '.app__overlay'
})

// Blog
window.PSVueBlog = new Vue({
  name: 'Blog',
  el: '.main-blog',
  data () {
    return {
      sortByOpen: false
    }
  },
  components: {
    'icon-chevron': require('../Vue/Icons/IconChevron.vue').default,
    'transition-expand': require('../Vue/Transitions/TransitionExpand.vue').default
  }
})

// Collection
window.PSVueCollection = new Vue({
  name: 'Collection',
	delimiters: ['${', '}'],
	comments: true,
  el: '.collection',
  data () {
    return {
      gridSize: 'md',
      searchActive: false
    }
  },
  components: {
    'collection-products': require('../Vue/Components/CollectionProducts.vue').default
  },
  methods: {
    updateGridSize (size) {
      this.gridSize = size
      window.localStorage.setItem('collection_grid_size', size)
    },
    toggleSearch () {
      this.searchActive = !this.searchActive
    }
  },
  mounted () {
    if (window.localStorage.getItem('collection_grid_size')) {
      this.gridSize = window.localStorage.getItem('collection_grid_size')
    }
  }
})

// Product
window.PSVueProduct = new Vue({
  name: 'Product',
  el: '.product',
  comments: true,
  data () {
    return {
      video: 'featured',
      isMobile: false
    }
  },
  components: {
    'quantity'   : require('../Vue/Components/Quantity.vue').default,
    'installment': require('../Vue/Components/Installment.vue').default,
    'tabs'       : require('../Vue/Components/Tabs.vue').default,
    'tab'        : require('../Vue/Components/Tab.vue').default,
    'slider'     : require('../Vue/Components/Slider.vue').default
  },
  mounted () {
    this.$el.style.display = 'grid'
    if (window.matchMedia(mq_breakpoints['--mobile-down']).matches) {
      this.isMobile = true
    }
  }
})
